import { createAction } from '@reduxjs/toolkit';

import { SET_SITEWIDE_BANNER } from '@/types/store/actions';
import { type SitewideBanner } from '@/types/store/reducers';

export const setSitewideBanner = createAction<SitewideBanner, typeof SET_SITEWIDE_BANNER>(
	SET_SITEWIDE_BANNER,
);
